import React, { useState, useEffect } from 'react';
import { Icon } from '../icons';

// Schermata di reset raggiunta dal link nell'email (?token=...). Prima valida il
// token lato server (mostra "link scaduto" se non valido), poi consente di
// scegliere la nuova password. Al termine torna al login con conferma.
function ResetPassword({ token, onDone }) {
  const [status, setStatus] = useState('checking'); // checking | valid | invalid
  const [username, setUsername] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch(`/api/auth/reset-password/${encodeURIComponent(token)}`)
      .then((res) => res.json().then((d) => ({ ok: res.ok, d })))
      .then(({ ok, d }) => {
        if (!alive) return;
        if (ok && d.valid) { setUsername(d.username || ''); setStatus('valid'); }
        else setStatus('invalid');
      })
      .catch(() => { if (alive) setStatus('invalid'); });
    return () => { alive = false; };
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next !== confirm) { setError('La conferma non coincide con la nuova password'); return; }
    if (next.length < 8) { setError('La nuova password deve avere almeno 8 caratteri'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: next }),
      });
      const data = await res.json();
      if (!res.ok) {
        // Token scaduto/consumato tra la validazione e l'invio: mostra lo stato dedicato.
        if (res.status === 400 && /link|scadut|utilizzat/i.test(data.error || '')) setStatus('invalid');
        setError(data.error || 'Errore');
        return;
      }
      onDone({ success: true, message: 'Password reimpostata. Ora puoi accedere con la nuova password.' });
    } catch {
      setError('Impossibile contattare il server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-hero">
        <div className="login-hero-top">
          <div className="login-logo"><Icon name="shield" size={22} strokeWidth={2} /></div>
          <div className="login-brand-text" style={{ color: '#fff' }}>
            <strong style={{ display: 'block' }}>HIPLAAS</strong>
            <span>Manager</span>
          </div>
        </div>
        <div className="login-hero-mid">
          <h2>Scegli una nuova password.</h2>
          <p>Imposta una password sicura per il tuo account HIPLAAS Manager.</p>
        </div>
        <div className="login-hero-list">
          <div><span className="login-hero-icon"><Icon name="shield" size={16} /></span>Almeno 8 caratteri</div>
          <div><span className="login-hero-icon"><Icon name="key" size={16} /></span>Diversa dallo username</div>
        </div>
      </div>

      <div className="login-panel">
        <div className="login-card">
          {status === 'checking' && (
            <>
              <h1>Verifica del link…</h1>
              <p className="subtitle">Un istante.</p>
            </>
          )}

          {status === 'invalid' && (
            <>
              <h1>Link non valido</h1>
              <p className="subtitle">Questo link di reset è scaduto o è già stato utilizzato.</p>
              <div className="msg msg-error" style={{ marginBottom: '1rem' }}>
                <Icon name="alert" size={16} />
                Richiedi un nuovo link dalla pagina di login, tramite "Password dimenticata?".
              </div>
              <button type="button" className="btn btn-primary btn-block" onClick={() => onDone({ success: false })}>
                Torna al login
              </button>
            </>
          )}

          {status === 'valid' && (
            <form onSubmit={submit}>
              <h1>Nuova password</h1>
              <p className="subtitle">Account: <strong>{username}</strong></p>

              {error && <div className="msg msg-error" style={{ marginBottom: '1rem' }}><Icon name="alert" size={16} />{error}</div>}

              <div className="field">
                <label htmlFor="new">Nuova password</label>
                <div className="input-with-action">
                  <input id="new" className="input" type={showPassword ? 'text' : 'password'} value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" required autoFocus />
                  <button type="button" className="input-action" onClick={() => setShowPassword((v) => !v)} aria-label={showPassword ? 'Nascondi password' : 'Mostra password'}>
                    <Icon name={showPassword ? 'eyeOff' : 'eye'} size={17} />
                  </button>
                </div>
              </div>
              <div className="field">
                <label htmlFor="cnf">Conferma nuova password</label>
                <input id="cnf" className="input" type={showPassword ? 'text' : 'password'} value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" required />
              </div>

              <button type="submit" className="btn btn-primary btn-block" disabled={loading} style={{ marginTop: '0.5rem' }}>
                {loading ? 'Reimpostazione…' : 'Reimposta password'}
              </button>
              <button type="button" className="btn btn-ghost btn-block" onClick={() => onDone({ success: false })} style={{ marginTop: '0.6rem' }}>
                Annulla
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
